import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "stroke-width": "1.5",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("g", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, [
      createElementVNode("path", { d: "m13.54 8.58 9.33 8.79a1.31 1.31 0 0 1 0 1.85l-.93.93a1.31 1.31 0 0 1-1.85 0l-8.79-9.33" }),
      createElementVNode("path", { d: "M3.85 8.54a19.06 19.06 0 0 0 7.41-7.41 1.31 1.31 0 0 1 1.85 0l3.51 3.51a1.32 1.32 0 0 1 0 1.86 18.1 18.1 0 0 0-7.41 7.4 1.31 1.31 0 0 1-1.85 0l-3.51-3.51a1.31 1.31 0 0 1 0-1.85m8.9 12.21a1.5 1.5 0 0 0-1.5-1.5h-7.5a1.5 1.5 0 0 0-1.5 1.5h0v2.5h10.5Zm-12 2.5h13.5" })
    ], -1)
  ]));
}
const legalJusticeHammerGavel = { render };
export {
  legalJusticeHammerGavel as default,
  render
};
//# sourceMappingURL=legal-justice-hammer-gavel.svg.js.map
